import { CountryAutocompleteField, DEFAULT_OPTION, withFieldGroup } from '@massilia/features'
import { Button } from '@massilia/ui'
import { addYears } from 'date-fns'
import { FileText, Plus, Trash2 } from 'lucide-react'

import type { ReservationSchema } from '@/lib/schemas'

import { DOCUMENT_TYPE_OPTIONS } from '@/routes/informations/-utils/constants'

export const IdentityDocumentsFormGroup = withFieldGroup({
  defaultValues: {} as {
    identityDocuments: Pick<
      ReservationSchema,
      'passengers'
    >['passengers'][number]['identityDocuments']
  },
  render: function IdentityDocuments({ group }) {
    return (
      <group.AppField mode="array" name="identityDocuments">
        {(fieldArray) => {
          const documents = fieldArray.state.value ?? []
          const usedTypes = documents.map((d) => d.type).filter(Boolean)
          const canAdd = documents.length < 2

          return (
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium tracking-wider text-stone-500 uppercase">
                  Documents d&apos;identite
                </span>
                {canAdd && (
                  <Button
                    className="h-7 gap-1 text-xs text-blue-600 hover:text-blue-800"
                    onClick={() => {
                      const nextType =
                        (['PASSPORT', 'CNI'] as const).find((t) => !usedTypes.includes(t)) ??
                        'PASSPORT'
                      fieldArray.pushValue({
                        documentNumber: '',
                        expiryDate: '',
                        issuingCountry: DEFAULT_OPTION,
                        type: nextType,
                      })
                    }}
                    size="sm"
                    type="button"
                    variant="ghost"
                  >
                    <Plus className="size-3.5" />
                    Ajouter
                  </Button>
                )}
              </div>

              {documents.length === 0 && (
                <p className="text-xs text-stone-400 italic">Aucun document renseigne</p>
              )}

              {documents.map((_doc, docIndex) => (
                <div
                  className="space-y-2 rounded-lg border border-stone-200 bg-stone-50/50 p-3"
                  key={docIndex}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <FileText className="size-3.5 text-stone-400" />
                      <span className="text-xs font-medium text-stone-600">
                        Document {docIndex + 1}
                      </span>
                    </div>
                    <Button
                      className="h-6 w-6 p-0 text-red-400 hover:text-red-600"
                      onClick={() => fieldArray.removeValue(docIndex)}
                      size="sm"
                      type="button"
                      variant="ghost"
                    >
                      <Trash2 className="size-3.5" />
                    </Button>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <group.AppField
                      name={`identityDocuments[${docIndex}].type`}
                      children={(field) => (
                        <field.SelectField label="Type" options={DOCUMENT_TYPE_OPTIONS} />
                      )}
                    />
                    <group.AppField
                      name={`identityDocuments[${docIndex}].documentNumber`}
                      children={(field) => (
                        <field.TextField label="Numero" placeholder="19DE71227" />
                      )}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <group.AppField
                      name={`identityDocuments[${docIndex}].issuingCountry`}
                      children={() => <CountryAutocompleteField label="Pays de délivrance" />}
                    />
                    <group.AppField
                      name={`identityDocuments[${docIndex}].expiryDate`}
                      children={(field) => <field.DateField endMonth={addYears(new Date(), 11)} label="Expiration" />}
                    />
                  </div>
                </div>
              ))}
            </div>
          )
        }}
      </group.AppField>
    )
  },
})
